export default "__VITE_PUBLIC_ASSET__5bca220e__"